import { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ArrowLeft } from 'react-feather';
import { useIntl } from 'react-intl';
import { Button } from 'reactstrap';
import { useSnackbar } from 'notistack';

import { Checkbox } from 'src/componentes/Form';
import MdiIcon from 'src/componentes/mdi-icon';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/errorHandler';
import Panel from 'src/componentes/panel';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';
import LoadingContainer from 'src/componentes/loading-container';

export default function ConfiguracaoDossieColaborador({
  disabled,
  onClickBack,
}) {
  const [secoes, setSecoes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const { terms: resources } = useAuth();

  const getSecoes = async () => {
    try {
      setIsLoading(true);
      const response = await http.post(
        'DossieColaborador/ObterSecoesDossieColaborador'
      );
      if (response.data) {
        setSecoes(response.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      errorHandler(error);
    }
  };

  useEffect(() => {
    getSecoes();
  }, []);

  const reorderList = (startIndex, endIndex) => {
    const newList = [...secoes];
    const [removed] = newList.splice(startIndex, 1);
    newList.splice(endIndex, 0, removed);

    return newList;
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const newList = reorderList(result.source.index, result.destination.index);
    setSecoes(newList);
  };

  const handleChangeVisivel = (field, value) => {
    const updatedSecoes = secoes.map((secao) => {
      if (secao.id === field) {
        return { ...secao, visivel: value.target.checked };
      }
      return secao;
    });
    setSecoes(updatedSecoes);
  };

  const handleChangeVisivelTodas = (value) => {
    const updatedSecoes = secoes.map((secao) => ({
      ...secao,
      visivel: value.target.checked,
    }));
    setSecoes(updatedSecoes);
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      await http.post(
        'DossieColaborador/AtualizarOrdemSecaoDossieColaborador',
        {
          secoes: secoes,
        }
      );

      enqueueSnackbar(intl.formatMessage({ id: 'salvoComSucesso' }), {
        variant: 'success',
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      errorHandler(error);
    }
  };

  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-between align-items-center w-100">
        <h3
          className={`mb-4 pb-md-2 ignoreInPrint w-100`}
          style={{ borderBottom: '1px solid #e4eaec' }}
        >
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <div
                className="text-primary cursor-pointer mr-2"
                style={{ marginTop: '-2px' }}
              >
                <ArrowLeft size={22} onClick={onClickBack} />
              </div>

              <span>
                {capitalizeFirstLetter(
                  intl.formatMessage(
                    { id: 'configuracoesDoDossie' },
                    { dossie: resources?.dossie }
                  )
                )}
              </span>
            </div>
          </div>
        </h3>
      </div>
      <p>
        {intl.formatMessage(
          {
            id: 'escolhaOQueDesejaVisualizarNoDossieDoColaborador',
          },
          { dossie: resources?.dossie }
        )}
      </p>
      <LoadingContainer isLoading={isLoading}>
        <Panel header={intl.formatMessage({ id: 'informacoesDoPerfil' })}>
          <hr />
          <div className="d-flex text-lg font-weight-bold">
            <div>{intl.formatMessage({ id: 'secoesAtivas' })}</div>
            <div className="text-right d-flex ml-auto">
              <span className="mr-2 ml-auto">
                {intl.formatMessage({ id: 'visivel?' })}
              </span>
              <div>
                <Checkbox
                  disabled={disabled}
                  type="switch"
                  id={`secao-visivel-todas`}
                  name={`secao-visivel-todas`}
                  checked={secoes.every((secao) => secao.visivel)}
                  onChange={(v) => handleChangeVisivelTodas(v)}
                />
              </div>
            </div>
          </div>
          <hr />
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="classificacoesContainer">
              {(provided) => (
                <div ref={provided.innerRef}>
                  {secoes.map((secao, index) => (
                    <div>
                      <Draggable index={index} draggableId={`${index}`}>
                        {(provided) => (
                          <div
                            className="mt-3 mb-1"
                            key={secao.id + '' + index}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            style={{
                              borderBottom: '1px solid #ddd',
                              ...provided.draggableProps.style,
                            }}
                          >
                            <div
                              className="d-flex"
                              {...provided.dragHandleProps}
                            >
                              {!disabled && (
                                <div
                                  className="text-center"
                                  {...provided.dragHandleProps}
                                >
                                  <MdiIcon size={22} icon="drag" />
                                </div>
                              )}
                              <div
                                className="ml-2 mt-1"
                                {...provided.dragHandleProps}
                              >
                                <div className="font-weight-bold">
                                  {intl.formatMessage(
                                    { id: secao.nome },
                                    {
                                      cursosextracurriculares:
                                        resources?.cursosextracurriculares,
                                    }
                                  )}
                                </div>
                              </div>
                              <div className="ml-auto">
                                <Checkbox
                                  className="ml-2"
                                  disabled={disabled}
                                  type="switch"
                                  id={`secao-visivel-${secao.nome}`}
                                  name={`secao-visivel-${secao.nome}`}
                                  checked={secao.visivel}
                                  onChange={(v) =>
                                    handleChangeVisivel(secao.id, v)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    </div>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Panel>
      </LoadingContainer>
      <div style={{ marginLeft: 'auto' }}>
        <Button
          className="bg-primary"
          onClick={() => handleSave()}
          iconSize={16}
        >
          {intl.formatMessage({ id: 'label.salvar' })}
        </Button>
      </div>
    </div>
  );
}
